import { theme } from '@febos-io/design';

import { amplifySignIn } from '../hooks';

export function SignInVerificationPage() {
  const { handleSignIn } = amplifySignIn.useSignIn();
  amplifySignIn.useSignInFederateEffect(handleSignIn);
  return (
    <theme.views.Login>
      Verificando
    </theme.views.Login>
  );
}

export default SignInVerificationPage;
